import React, { useState, Suspense, useContext } from "react";
import { Box, Container, Grid, Paper } from "@mui/material";
import OpenDemoAccount from "../auth/OpenDemoAccount";
import { useTranslation } from 'react-i18next';
import { ThemeContext } from "../../../context/ThemeContext";
import UserName from "../auth/UserName";
import { useMediaQuery, useTheme } from "@mui/material";
import Login from "../Login/Login";

const MainAuth = ({ onClose }) => {
    const { t } = useTranslation();
    const { darkMode } = useContext(ThemeContext)
    // const storedName = localStorage.getItem('username')
    // const savedPassword = localStorage.getItem('password')
    const savedCredentials = JSON.parse(localStorage.getItem("savedCredentials") || "{}");

    const storedName = savedCredentials.username;
    const savedPassword = savedCredentials.password;
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const imgSrc = darkMode ? '/hs-white.png' : '/hs-logo.png'
    const logoImg = darkMode ? "/Vfx-logo_white.png" : "/Vfx logo.png"
    return (
        <>
            <Suspense fallback={<div>Loading translations...</div>}>
                <Container maxWidth={isMobile ? false : "md"}>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', }}>
                        <Box sx={{ p: 4, width: 400, borderRadius: 4, textAlign: 'center', pt: 2, backgroundColor: darkMode ? '#0f1720' : 'var(--white)', boxShadow: darkMode ? 'none' : '0px 0px 40px rgba(0, 0, 0, 0.1)', }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', }}><img src={logoImg} alt="hs" style={{ height: 38 }} className='ms-2 my-2' /> </Box>
                            <div style={{ backgroundColor: darkMode ? '#0f1720' : 'var(--white)', overflow: "hidden", width: "100%", position: "relative", }}>
                                <Login />
                            </div>
                            <div className='opacity-50' style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: '1rem' }}>
                                <small>Powered by </small><a href="https://hybridsolutions.com/" target='_blank'><img src={imgSrc} alt="hs" style={{ height: darkMode ? 40 : 20 }} className='ms-2' />
                                </a>
                            </div>
                        </Box>
                    </Box>
                </Container>
            </Suspense>
        </>
    );
};

export default MainAuth;
